const Avatar = ({avatar, voice, configuration}) => {
    if (avatar) {

        return "url(" + avatar + ")";
    } else if (!avatar && (voice === 'nova' || voice === 'shimmer')) {

        return "url(" + (configuration.avatar.female) + ")";
    } else if (!avatar && !(voice === 'nova' || voice === 'shimmer')) {

        return "url(" + (configuration.avatar.male) + ")";
    }
};

export default Avatar;
